import { Fragment } from "react";
import { handleFocus, handleBlur } from "../../../functions/utilities";

const WodaOdczytyRazemSzczegolyEdytujKwoty = props => {

    const { edytowanyZakres, setEdytowanyZakres } = props;

    const handleMz = e => setEdytowanyZakres( prevState => ({...prevState, moc_zamowiona: e.target.value}) );
    const handleEp = e => setEdytowanyZakres( prevState => ({...prevState, energia_pobrana: e.target.value}) );
    const handleM3 = e => setEdytowanyZakres( prevState => ({...prevState, metr_3_zimnej: e.target.value}) );

    return (
        <Fragment>
            <div className="row">
                <div className="kwoty">
                    <label htmlFor="mz">
                        Moc zamówiona:  
                    </label>
                    <input 
                        type="number" 
                        id="mz" 
                        value={edytowanyZakres?.moc_zamowiona}
                        onChange={handleMz}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div className="row">
                <div className="kwoty">
                    <label htmlFor="ep">
                        Energia pobrana:  
                    </label>
                    <input 
                        type="number" 
                        id="ep" 
                        value={edytowanyZakres?.energia_pobrana}
                        onChange={handleEp}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div className="row">
                <div className="kwoty">
                    <label htmlFor="m3">
                        Kosz 1m³ zimnej wody (wg PWiK):
                    </label>
                    <input 
                        type="number" 
                        id="m3" 
                        value={edytowanyZakres?.metr_3_zimnej}
                        onChange={handleM3}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default WodaOdczytyRazemSzczegolyEdytujKwoty;